const addDefaultLang = () => {
  const defaultLang = 'id'
  localStorage.setItem('lang', defaultLang)
  return defaultLang
}
const lang = localStorage.getItem('lang')
  ? localStorage.getItem('lang')
  : addDefaultLang()

const state = () => {
  return {
    lang,

    companyTypeOptions: [
      {
        label: 'Pemilik Proyek',
        value: 'PROJECT_OWNER'
      },
      {
        label: 'Arsitek',
        value: 'ARCHITECT'
      },
      {
        label: 'Developer',
        value: 'DEVELOPER'
      },
      {
        label: 'Kontraktor',
        value: 'CONTRACTOR'
      },
      {
        label: 'Lainnya',
        value: 'OTHER'
      }
    ],

    paymentTerms: [
      {
        label: 'CBD',
        value: 'CBD'
      },
      {
        label: 'COD',
        value: 'COD'
      },
      {
        label: 'Giro Mundur',
        value: 'GIRO'
      },
      {
        label: 'Termin',
        value: 'TERMIN'
      },
      {
        label: 'Tunai',
        value: 'TRANSFER'
      },
      {
        label: 'Virtual Account',
        value: 'VIRTUAL_ACCOUNT'
      }
    ],

    suppStatus: [
      {
        label: 'Aktif',
        value: 'ACTIVE'
      },
      {
        label: 'Tidak Aktif',
        value: 'NOT_ACTIVE'
      }
    ],

    legalityStatus: [
      {
        label: 'Belum Unggah',
        value: 'INCOMPLETE'
      },
      {
        label: 'Menunggu Konfirmasi',
        value: 'WAITING'
      },
      {
        label: 'Ditolak',
        value: 'REVISE'
      },
      {
        label: 'Lengkap',
        value: 'COMPLETED'
      }
    ],

    digitalInvoiceStatus: [
      {
        label: 'Aktif',
        value: 'ACTIVE'
      },
      {
        label: 'Tidak Aktif',
        value: 'INACTIVE'
      }
    ],

    paymentDueDate: {
      GIRO: [1, 7, 14, 21, 30, 45, 50, 60, 75, 90],
      TERMIN: [30, 60, 75, 90]
    },

    terminDate: {
      customer: [7, 14, 30, 40, 45, 60, 90],
      paper: [30, 60, 90]
    },

    shipping: [
      { label: 'Gratis Ongkir oleh Vendor', value: 'VENDOR' },
      { label: 'Gratis Ongkir', value: 'FREE_SHIPPING' },
      { label: 'JM Delivery', value: 'JM' },
      { label: 'Pickup Di Vendor', value: 'PICKUP' },
      { label: 'Berkala', value: 'PERIODIC' }
    ],

    companyType: [
      {
        label: 'PT',
        value: 'PT'
      },
      {
        label: 'CV',
        value: 'CV'
      },
      {
        label: 'UD',
        value: 'UD'
      },
      {
        label: 'TB',
        value: 'TB'
      },
      {
        label: 'Firma',
        value: 'FIRMA'
      },
      {
        label: 'Lainnya',
        value: 'OTHER'
      }
    ],

    vendorType: [
      {
        label: 'Agent',
        value: 'AGENT'
      },
      {
        label: 'Brand Owner',
        value: 'BRAND_OWNER'
      },
      {
        label: 'Distributor',
        value: 'DISTRIBUTOR'
      },
      {
        label: 'Retailer',
        value: 'RETAILER'
      },
      {
        label: 'Sole Distributor',
        value: 'SOLE_DISTRIBUTOR'
      }
    ],

    userType: [
      {
        label: 'Bisnis',
        value: 'BUSINESS'
      },
      {
        label: 'Retail',
        value: 'RETAIL'
      }
    ],

    costType: [
      {
        label: 'Debit',
        value: 'DEBIT'
      },
      {
        label: 'Kredit',
        value: 'CREDIT'
      }
    ],

    lat: -6.175396150166771,
    lng: 106.82718599999998,
    zoom: 18,

    imageTypes: ['png', 'jpg', 'jpeg', 'webp', 'gif'],

    pdfDownloadBankLists: [
      {
        label: 'BCA',
        value: 'BCA'
      },
      {
        label: 'Mandiri',
        value: 'MANDIRI'
      },
      {
        label: 'BCA Modalku',
        value: 'BCA_MODALKU'
      },
      {
        label: 'BSI',
        value: 'BSI'
      }
    ],

    customerGrade: [
      {
        label: 'Retail',
        value: 'RETAIL'
      },
      {
        label: 'Grade C - Tunai',
        value: 'GradeCTransfer'
      },
      {
        label: 'Grade C - Tempo',
        value: 'GradeCTermin'
      },
      {
        label: 'Grade B',
        value: 'GradeB'
      },
      {
        label: 'Grade A',
        value: 'GradeA'
      }
    ],

    bnpl: [
      {
        label: 'Paper',
        value: 'PAPER'
      },
      {
        label: 'JM Internal',
        value: 'JM'
      }
    ],

    eventTracker: [
      {
        label: 'Ecommerce',
        value: 'ECOM'
      },
      {
        label: 'CMS',
        value: 'CMS'
      },
      {
        label: 'IBT',
        value: 'IBT'
      }
    ],

    resetForm: false,
    formIsSubmitted: false,
    formError: []
  }
}

const actions = {
  FILTER_HANDEL_INPUT (context, payload) {
    const { list, data } = payload
    const submitResult = {}

    for (const item of list) {
      submitResult[item] = data[item]
    }

    const resp = Object.fromEntries(
      Object.entries(submitResult).filter(([_, v]) => v !== null && v !== '')
    )

    return resp
  },

  FILTER_SELECT_FN (context, [val, data, type]) {
    const needle = val.toLowerCase()

    return data.filter((item) => {
      let newValue
      if (
        (item.label && item.label.toLowerCase().indexOf(needle) > -1) ||
        (item.detail && item.detail.toLowerCase().indexOf(needle) > -1) ||
        (item.receiver && item.receiver[0].name.toLowerCase().indexOf(needle) > -1)
      ) {
        newValue = item
      }

      return newValue
    })
  },

  SNAKE_TO_CAMEL (context, text) {
    return text.replace(/(_\w)/g, function (k) {
      return k[1].toUpperCase()
    })
  },

  DIGIT_GROUP (context, val) {
    let _val = ''
    if (val) {
      _val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }

    if (val === 0) _val = 0
    return _val
  },

  GENERATE_FORMDATA (context, payload) {
    const formData = new FormData()
    for (const key in payload) {
      if (payload[key] !== undefined) {
        if (!payload[key]) continue

        if (payload[key].constructor === Array) {
          payload[key].forEach((p, idx) => {
            for (const k in p) {
              if (p[k] === null) continue
              formData.append(`${key}[${idx}][${k}]`, p[k])
            }
          })
        } else {
          formData.append(key, payload[key])
        }
      }
    }
    return formData
  }
}

const mutations = {
  RESET_FORM (state) {
    state.formError = []
    state.resetForm = !state.resetForm
  },
  FORM_IS_SUBMITTED (state) {
    state.formError = []
    state.formIsSubmitted = !state.formIsSubmitted
  },
  FORM_ERROR (state, value) {
    state.formError.push(value)
  }
}

export default {
  state,
  actions,
  mutations
}
